import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { decamelizeKeys } from 'humps';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { CheckoutPayloadProps } from '../api/request';

export const useCheckoutMutation = () => {
  const axios = useAxios();

  const handleEstimate = (payload: CheckoutPayloadProps) => {
    return axios.post<
      AxiosResponse<{ bookingId: string; transactionId: string; payment: any; paymentStatus: 'success' | 'pending' }>
    >(ApiRoutes.checkout, decamelizeKeys(payload));
  };

  return useMutation(handleEstimate, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
